import React from 'react';

import ImagePicker from 'components/ImagePicker';
import ShowConfirmationModal from 'containers/ShowConfirmationModal';
import { wrapPromise } from 'utils/functional';

import Field from './Field';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ImagePickerField = ({
  altText,
  aspectRatio,
  defaultImage,
  name,
  label,
  description,
  previewWidth,
  previewHeight,
  format,
  message,
  centerButton,
  overlayButton,
  disableCrop,
  confirmModal,
  onChange,
  'data-qa-id': qaId,
  recommendedDimensions,
  inlineLabel,
  noMargin,
  extraAnalyticsData,
  ...props
}: {
  altText?: string;
  aspectRatio?: number;
  defaultImage?: React.ElementType;
  hideRemove?: boolean;
  id?: string;
  name: string;
  label?: string;
  description?: string;
  previewCrop?: boolean;
  previewCropToCircle?: boolean;
  previewWidth?: number;
  previewHeight?: number;
  format?: 'logo' | 'banner';
  message?: string;
  buttonOnly?: boolean;
  centerButton?: boolean;
  overlayButton?: boolean;
  disableCrop?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  confirmModal?: Record<string, any>;
  'data-qa-id'?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
  noMargin?: boolean;
  inlineLabel?: boolean;
  recommendedDimensions?: {
    width: number;
    height: number;
  };
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraAnalyticsData?: Record<string, any>;
}) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/function-component-definition, react/no-unstable-nested-components
  const Picker = (pickerProps) => (
    <ImagePicker
      altText={altText}
      defaultImage={defaultImage}
      extraAnalyticsData={extraAnalyticsData}
      name={name}
      previewWidth={previewWidth}
      previewHeight={previewHeight}
      format={format}
      message={message}
      centerButton={centerButton}
      overlayButton={overlayButton}
      disableCrop={disableCrop}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...pickerProps}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );

  return (
    <Field
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      name={name}
      label={label}
      inlineLabel={inlineLabel}
      noMargin={noMargin}
      description={description}
      renderInput={({ value, qaId: autoQaId, updateValue }) =>
        confirmModal ? (
          <ShowConfirmationModal
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...confirmModal}
            onConfirm={wrapPromise(() => {
              if (onChange) {
                onChange(null);
              } else {
                updateValue(null);
              }
            })}
            render={({ showModal: showConfirmationModal }) => (
              <Picker
                showConfirmationModal={showConfirmationModal}
                image={value}
                data-qa-id={qaId || autoQaId}
                onChange={onChange || updateValue}
                recommendedDimensions={recommendedDimensions}
                label={label}
              />
            )}
          />
        ) : (
          <Picker
            image={value}
            data-qa-id={qaId || autoQaId}
            onChange={onChange || updateValue}
            recommendedDimensions={recommendedDimensions}
            label={label}
          />
        )
      }
    />
  );
};

export default ImagePickerField;
